/* System defined core library */
import { Component, HostListener, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

/* User defined library/components */
import { DynamicComponentService } from '../../../shared/services/dynamic.component.service';
import { RoutingService } from '../../../shared/services/routing.service';
import { TimerService } from '../../../shared/services/timer.service';
import { UtilityService } from '../../../shared/services/utility.service';
import { SelectedExamDetailService } from '../../shared/services/selected-exam-detail.service';

/* User defined models */
import { AppointmentDetail } from '../../../shared/models/scheduling/appointmentdetail.model';
import { AppointmentSlot } from '../../../shared/models/scheduling/appointmentSlot.model';
import { Hold } from '../../../shared/models/scheduling/hold.model';

/* User defined enums/constants */
import { ComponentType } from '../../../shared/enums/scheduling.enum';


@Component({
  selector: 'app-find-availability-proctor',
  templateUrl: './find-availability-proctor.component.html',
  providers: [DynamicComponentService]
})
/** schedule-proctor component*/
export class FindAvailabilityProctorComponent implements OnInit {
  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    this.clearDataOnGoingBack();
  }

  /* User defined private/public variables */
  selectedAppointmentData: AppointmentDetail[] = [];
  public terminationText: string = 'reconfirmationComponent.termUrl';
  public terminationUrl: string;
  public setSeatAvailabilityPathLock: boolean;

  /* Service subscriptions */
  selectedAppointments$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private routingService: RoutingService,
    private selectedExamDetailService: SelectedExamDetailService,
    private timerService: TimerService,
    private utilityService: UtilityService
  ) {
    this.selectedAppointments$ = selectedExamDetailService.selectedAppointmentDetails.subscribe(
      selectedAppointments => {
        this.selectedAppointmentData = selectedAppointments;
      });

    this.terminationUrl = this.selectedExamDetailService.terminationUrl;
    this.setSeatAvailabilityPathLock = this.selectedExamDetailService.setSeatAvailabilityPathLock;
  }

  /* Initialize the component & call required methods when component loaded first time. */
  ngOnInit() {
    sessionStorage.setItem('previousUrl', window.location.pathname);
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.FindAvailabilityProctorComponent)) return;

    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';
    if (clientCode === 'cfa' || clientCode === 'cfad' || clientCode === 'cfas') {
      this.terminationText = 'CFA_Cancel_Term';
    }
  }

  /* Move back a page. */
  goToPrevPage(): void {
    this.clearDataOnGoingBack();
    this.routingService.backwardNavigationSearch(ComponentType.ScheduleProctorComponent);
  }

  /* Use to clear details on navigating backward */
  clearDataOnGoingBack(): void {
    this.selectedExamDetailService.setProctors(null);
    this.selectedExamDetailService.setSlot(null);
    this.selectedExamDetailService.setSelectedStartDate(null);
    this.selectedExamDetailService.setSelectedEndDate(null);
    this.selectedExamDetailService.setHold(null);
    this.timerService.clearClock();

    this.selectedExamDetailService.scheduleFee = {
      totalAmount: 0,
      currency: null
    };

    this.selectedAppointmentData.forEach((appointment) => {
      appointment.appointmentSlot = new AppointmentSlot();
      appointment.hold = new Hold();
      appointment.holdId = undefined;
      appointment.status = undefined;
    });

    this.selectedExamDetailService.setSelectedAppointmentDetails(this.selectedAppointmentData);
  }

  goToHome() {
    this.routingService.homeNavigation();
  }

  /* Go to client page after appointment is scheduled. */
  goToTerminationUrl(): void {
    this.routingService.navigateToTerm();
  }
}
